import { render, staticRenderFns } from "./SyncFailList.vue?vue&type=template&id=1ba09845&scoped=true&"
import script from "./SyncFailList.vue?vue&type=script&lang=ts&"
export * from "./SyncFailList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba09845",
  null
  
)

export default component.exports